var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable max-statements */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useRef, useEffect } from 'react';

import { useLoaderData, useRevalidator, useBlocker } from 'react-router';

import { useSetAtom } from 'jotai';
import { cloneDeep, isEqual } from 'lodash';
import { Translate } from "../../../../I18N";
import * as SettingsAPI from "../../../api/settings";
import { notificationAtom } from "../../../atoms";
import { settingsAtom } from "../../../atoms/settingsAtom";
import { Button, Table, Sidepanel, ConfirmNavigationModal } from "../../../Components/UI";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { MenuForm } from "./components/MenuForm";
import { columns } from "./components/TableComponents";
import { sanitizeIds } from "./shared";

const menuConfigloader =
(headers) =>
async () => {
  const tableRows = (await SettingsAPI.getLinks(headers)).map((link) => {
    const linkWithRowId = _objectSpread(_objectSpread({}, link), {}, { rowId: link._id });
    if (link.sublinks) {
      linkWithRowId.subRows = link.sublinks.map((sublink, index) => _objectSpread(_objectSpread({},
      sublink), {}, {
        rowId: `${link._id}-${index}` })
      );
    }
    return linkWithRowId;
  });
  return tableRows;
};

const MenuConfig = () => {
  const links = useLoaderData();
  const [linkState, setLinkState] = useState(links);
  const prevLinks = useRef(cloneDeep(links));
  const [selectedLinks, setSelectedLinks] = useState({});
  const [isSidepanelOpen, setIsSidepanelOpen] = useState(false);
  const setNotifications = useSetAtom(notificationAtom);
  const revalidator = useRevalidator();
  const [formValues, setFormValues] = useState();
  const [showModal, setShowModal] = useState(false);
  const setSettings = useSetAtom(settingsAtom);

  const areEqual = isEqual(linkState, prevLinks.current);

  const blocker = useBlocker(!areEqual);

  const edit = (row) => {
    const parent = row.getParentRow();
    const link = row.original;
    setFormValues(_objectSpread(_objectSpread({}, link), {}, { parentId: parent === null || parent === void 0 ? void 0 : parent.id }));
    setIsSidepanelOpen(true);
  };

  const addLink = () => {
    setFormValues({ title: '', type: 'link', url: '' });
    setIsSidepanelOpen(true);
  };

  const addGroup = () => {
    setFormValues({ title: '', type: 'group', subRows: [] });
    setIsSidepanelOpen(true);
  };

  const save = async () => {
    const settings = await SettingsAPI.saveLinks(linkState.map(sanitizeIds));
    setSettings(settings);
    await revalidator.revalidate();
    setNotifications({
      type: 'success',
      text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Updated")
    });
  };

  const deleteSelected = () => {
    let newLinks = linkState.filter((link) => !(link.rowId && link.rowId in selectedLinks));

    newLinks = newLinks.map((link) => {
      if (link.subRows) {
        link.subRows = link.subRows.filter(
          (sublink) => !(sublink.rowId && sublink.rowId in selectedLinks)
        );
      }
      return link;
    });

    setLinkState(newLinks);
  };

  const formSubmit = (values) => {
    setLinkState(values);
    setIsSidepanelOpen(false);
  };

  useEffect(() => {
    if (blocker.state === 'blocked') {
      setShowModal(true);
    }
  }, [blocker, setShowModal]);

  useEffect(() => {
    prevLinks.current = cloneDeep(links);
    setLinkState(links);
  }, [links]);

  return (/*#__PURE__*/
    _jsx("div", { className: "w-full h-full overflow-y-auto", "data-testid": "settings-account" }, void 0, /*#__PURE__*/
    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Menu" }), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx(Table, {
      enableSelections: true,
      dnd: { enable: true },
      columns: columns({ edit }),
      data: linkState,
      onChange: ({ rows, selectedRows }) => {
        setLinkState(rows);
        setSelectedLinks(selectedRows);
      },
      header: /*#__PURE__*/
      _jsx(Translate, { className: "text-base font-semibold text-left text-gray-900 bg-white" }, void 0, "Menu"

      ) }

    )
    ), /*#__PURE__*/
    _jsx(SettingsContent.Footer, {
      className: Object.keys(selectedLinks).length ? 'bg-primary-50' : '' }, void 0,

    Object.keys(selectedLinks).length > 0 && /*#__PURE__*/
    _jsx("div", { className: "flex gap-2 items-center" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      type: "button",
      onClick: deleteSelected,
      color: "error",
      "data-testid": "menu-delete-link" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Delete")
    ), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Selected"), "\xA0", Object.keys(selectedLinks).length, "\xA0", /*#__PURE__*/
    _jsx(Translate, {}, void 0, "of"), "\xA0",
    linkState.reduce(
      (acc, link) => {var _link$subRows;return acc + (link.type === 'group' ? (((_link$subRows = link.subRows) === null || _link$subRows === void 0 ? void 0 : _link$subRows.length) || 1) + 1 : 1);},
      0
    )
    ),

    Object.keys(selectedLinks).length === 0 && /*#__PURE__*/
    _jsx("div", { className: "flex justify-between w-full" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, { type: "button", onClick: addLink, "data-testid": "menu-add-link" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add link")
    ), /*#__PURE__*/
    _jsx(Button, { type: "button", onClick: addGroup, "data-testid": "menu-add-group" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add group")
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      type: "button",
      onClick: save,
      color: "success",
      disabled: areEqual,
      "data-testid": "menu-save" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Save")
    )
    )
    )

    )
    ), /*#__PURE__*/
    _jsx(Sidepanel, {
      title: /*#__PURE__*/
      _jsx(Translate, { className: "uppercase" }, void 0,
      `${(formValues === null || formValues === void 0 ? void 0 : formValues.title) === '' ? 'New' : 'Edit'} ${
      (formValues === null || formValues === void 0 ? void 0 : formValues.type) === 'group' ? 'Group' : 'Link'}`

      ),

      isOpen: isSidepanelOpen,
      closeSidepanelFunction: () => setIsSidepanelOpen(false),
      size: "medium",
      withOverlay: true }, void 0, /*#__PURE__*/

    _jsx(MenuForm, {
      submit: formSubmit,
      closePanel: () => setIsSidepanelOpen(false),
      linkToEdit: formValues,
      links: linkState }
    )
    ),
    showModal && /*#__PURE__*/
    _jsx(ConfirmNavigationModal, { setShowModal: setShowModal, onConfirm: blocker.proceed })

    ));

};


export { MenuConfig, menuConfigloader };